"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VERTICAL_PADDING = exports.TextAreaStyled = exports.SIZING_BUFFER = exports.LINE_HEIGHT_PX = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _designTokens = require("@smartsheet/design-tokens");
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _sdsThemeInternal = require("@smartsheet/sds-theme-internal");
var _createFocusRingStyles = require("../../../util/createFocusRingStyles");
var _withFocusClassName = require("../../../util/withFocusClassName");
var _useFocusMode = require("../../focusMode/hooks/useFocusMode");
var _formInputTheme = require("../../textinput/styled/formInputTheme");
// These are used to derive the fact that a 4 line textarea with
// box-sizing: border-box is exactly 94px high, so we can avoid
// magic numbers.
const VERTICAL_PADDING = 11;
exports.VERTICAL_PADDING = VERTICAL_PADDING;
const LINE_HEIGHT_PX = 18;
exports.LINE_HEIGHT_PX = LINE_HEIGHT_PX;
const SIZING_BUFFER = 1;
exports.SIZING_BUFFER = SIZING_BUFFER;
const textAreaTheme = (0, _sdsThemeInternal.themed)({
  verticalPadding: {
    rest: {
      "lodestar-light": VERTICAL_PADDING,
      "ursa-light": VERTICAL_PADDING - 5
    },
    active: {
      "lodestar-light": VERTICAL_PADDING,
      "ursa-light": VERTICAL_PADDING - 6
    },
    error: {
      "lodestar-light": VERTICAL_PADDING,
      "ursa-light": VERTICAL_PADDING - 6
    }
  },
  horizontalPadding: {
    rest: {
      "lodestar-light": 12,
      "ursa-light": 8
    },
    active: {
      "lodestar-light": 12,
      "ursa-light": 7
    },
    error: {
      "lodestar-light": 12,
      "ursa-light": 7
    }
  }
});
const TextAreaStyled = (0, _withFocusClassName.withFocusToggleClassName)((0, _styled.default)("textarea")`
    border-style: solid;
    border-width: ${_formInputTheme.getBorderWidth}px;
    border-color: ${_formInputTheme.getBorderColor};
    border-radius: ${_ref => {
  let {
    themeMode
  } = _ref;
  return _formInputTheme.formInputTheme.borderRadius(themeMode);
}};
    background-color: ${_formInputTheme.getBackgroundColor};

    // If inline, this will include a bit of weird height at the bottom.
    display: block;

    padding: ${_ref2 => {
  let {
    themeMode,
    validationState,
    isFocused,
    focusMode
  } = _ref2;
  return `
        ${textAreaTheme.verticalPadding[(0, _formInputTheme.getStylingState)({
    validationState,
    isFocused,
    focusMode
  })](themeMode)}px
        ${textAreaTheme.horizontalPadding[(0, _formInputTheme.getStylingState)({
    validationState,
    isFocused,
    focusMode
  })](themeMode)}px
        ${textAreaTheme.verticalPadding[(0, _formInputTheme.getStylingState)({
    validationState,
    isFocused,
    focusMode
  })](themeMode) - SIZING_BUFFER}px
    `;
}};
    width: 100%;
    box-sizing: border-box;
    transition: background-color 100ms ease-in-out;
    resize: ${props => props.disableManualResize ? "none" : "vertical"};
    color: ${(0, _designTokensReact.color)("color--text--neutral--strong")};

    /* Font */
    font-size: ${_ref3 => {
  let {
    themeMode
  } = _ref3;
  return _formInputTheme.formInputTheme.fontSize.box(themeMode);
}};
    font-weight: ${_ref4 => {
  let {
    themeMode
  } = _ref4;
  return _formInputTheme.formInputTheme.fontWeight(themeMode);
}};
    line-height: ${LINE_HEIGHT_PX}px;
    font-family: inherit;
    &::placeholder {
        color: ${_ref5 => {
  let {
    themeMode
  } = _ref5;
  return _formInputTheme.formInputTheme.placeholderColor.rest(themeMode);
}};
    }

    &:hover::placeholder {
        color: ${_ref6 => {
  let {
    themeMode
  } = _ref6;
  return _formInputTheme.formInputTheme.placeholderColor.hover(themeMode);
}};
    }

    // Some high-contrast modes turn off box-shadows. In that case, we'll want to allow those HC
    // stylesheets to provide their own outline colors rather than turning off outlines entirely.
    outline: 3px solid transparent;
    body.${_useFocusMode.SHOW_FOCUS_MARKER} &:focus {
        ${getFocusStyles}
    }
`);
exports.TextAreaStyled = TextAreaStyled;
function getFocusStyles(_ref7) {
  let {
    themeMode,
    validationState
  } = _ref7;
  // Normally we'd use createFocusRingStyles here but we can't do that here since
  // you cannot use a ::before element in a textarea.
  switch (themeMode) {
    case "ursa-light":
      return `
                box-shadow:
                    0 0 0 ${_designTokens.border.width10} ${_createFocusRingStyles.focusRingTheme.innerColor(themeMode)},
                    0 0 0 calc(1px + ${_designTokens.border.width20}) ${_createFocusRingStyles.focusRingTheme.outerColor(themeMode)}
                ;
            `;
    default:
      return `
                border-color: ${validationState === "error" ? _formInputTheme.formInputTheme.borderColor.error(themeMode) : _formInputTheme.formInputTheme.borderColor.focus(themeMode)};
            `;
  }
}
//# sourceMappingURL=TextAreaStyled.js.map